module.exports = __webpack_public_path__ + "img/filtro.8f3c95eb.svg";